import axios from "axios/index";
import * as types from "../store/mutation-types";
import store from '~/store'

export default {
    async getUsers (cb) {
        const params = {}

        const {data} = await axios.get('/api/users', params)

        cb(data.data)
    },

    async getUserDetail (userId, cb) {
        const params = {}

        const {data} = await axios.get('/api/users/'+userId, params)

        cb(data.data)
    },

    async deleteUser (userId, cb) {
        const params = {}

        await axios.delete('/api/users/'+userId, params)

        cb()

    },

    async updateUser (userId, form) {
        const {data} = await form.patch('/api/users/'+userId)

        if (form.successful) {
            store.dispatch('user/updateUser', data)
        }
        return form.successful;
    },

    async inviteUser (form) {
        await form.post('/api/users')

        return form.successful
    },

    async claimUser (form) {
        const {data} = await form.post('/api/users/claim');
        if (form.successful) {
            // Save the token.
            store.dispatch('auth/saveToken', {
                token: data.token,
                remember: false
            })

            // Fetch the user.
            await store.dispatch('auth/fetchUser')
        }
        return form.successful;
    },

    async resendInvite (userId, cb) {
        const params = {}

        const {data} = await axios.post('/api/users/resend_invite/'+userId, params)

        store.dispatch('user/updateUser', data)

        cb()

    },

    async sendLostPassword (userId, cb) {
        const params = {}

        const {data} = await axios.post('/api/users/lost_password/'+userId, params)

        cb()

    },

    async searchUsers(searchTerm) {
        const {data} = await axios.get(`/api/users/search?q=${searchTerm}`)
        return data.data;
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/api/users.js